import { all, put, takeLatest } from 'redux-saga/effects';
import moment from 'moment';
import { ON_LOAD_MESSAGE_LIST, ON_LOAD_USER_CONVERSATION_LIST } from './constants';
import * as ChatActions from './action';
import { onDisplayAlert } from '../../utils/alerts/alerts';

function* getConversationsUserList({ payload }) {
  try {
    // This must be changed since it is not optimal at all, it is temporary.
    const { messages, users, cognitoId } = payload;
    if (users.length > 0) {
      let filterMessagesUser = [];

      const filterTransmitter = messages.filter((message) => message.handle === cognitoId);
      const filterReceiver = messages.filter((message) => message.sendTo === cognitoId);
      filterMessagesUser = [...filterMessagesUser, ...filterTransmitter, ...filterReceiver];

      const contactListIds = [];
      filterMessagesUser.forEach((men) => {
        if (cognitoId === men.handle) {
          contactListIds.push(men.sendTo);
        } else if (cognitoId === men.sendTo) {
          contactListIds.push(men.handle);
        }
      });

      const dataArr = new Set(contactListIds);
      const result = [...dataArr];
      const contactListArray = result.map((cognito) => users.find((u) => u.cognito_id === cognito));
      yield put(ChatActions.onLoadUserConversationListSuccess(contactListArray));
    }
  } catch (error) {
    console.log(error);
    onDisplayAlert({ title: 'Error loading user conversations', description: '', type: 'error' });
  }
}

function* getMessagesByUser({ payload }) {
  const { messages, cognitoId, activeUserConversation } = payload; // owner: true,
  const messageList = [];

  messages.forEach((message) => {
    if (message.handle === cognitoId && message.sendTo === activeUserConversation.cognito_id) {
      messageList.push({ ...message, owner: true });
    } else if (
      message.handle === activeUserConversation.cognito_id &&
      message.sendTo === cognitoId
    ) {
      messageList.push({ ...message, owner: false });
    }
  });

  const sortedMessages = messageList.sort(
    (a, b) => moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf(),
  );

  yield put(ChatActions.onLoadMessageListSuccess(sortedMessages));
}

function* ActionWatcher() {
  yield takeLatest(ON_LOAD_USER_CONVERSATION_LIST, getConversationsUserList);
  yield takeLatest(ON_LOAD_MESSAGE_LIST, getMessagesByUser);
}

export default function* ChatSaga() {
  yield all([ActionWatcher()]);
}
